export default {
  mounted_course: {},
  lesson_selected: {},
};
